import { api } from './api/client';

/**
 * L'abonnement aux notifications de cet appareil, tel que le navigateur le garde (chantier
 * notifications-socle, ticket 03). Ici, dans `partage/`, parce que deux sujets s'en servent : le
 * panneau Notifications du téléphone, et « Sortir » (`useDeconnexion`), d'où qu'on sorte :
 * couché, le téléphone sort par le cadre de l'ordinateur. Abonner, et le reste de ce qui parle
 * au navigateur : `telephone/cetAppareil.ts`.
 */

/** L'abonnement présent dans le navigateur de cet appareil, ou `null` (aucun, ou pas de notifications). */
export async function abonnementDeCetAppareil(): Promise<PushSubscription | null> {
  try {
    const inscrit = await navigator.serviceWorker.getRegistration();
    return inscrit ? await inscrit.pushManager.getSubscription() : null;
  } catch {
    return null;
  }
}

/**
 * Éteindre, ou Sortir : le serveur oublie cet appareil, puis le navigateur se désabonne. Le
 * navigateur se désabonne même si le serveur ne répond pas : l'envoi suivant lui reviendra
 * « parti » et l'effacera (ticket 01). Ne lève jamais.
 */
export async function desabonnerCetAppareil(): Promise<void> {
  const abonnement = await abonnementDeCetAppareil();
  if (!abonnement) return;
  try {
    await api.desabonnerCetAppareil(abonnement.endpoint);
  } catch {
    // 404 : déjà oublié ; pas de réseau : voir plus haut.
  }
  await abonnement.unsubscribe().catch(() => false);
}

/**
 * Sortir : désabonner cet appareil avant la déconnexion, quatre secondes au plus ; la sortie se
 * fait quand même si le désabonnement échoue ou traîne. Sans abonnement (l'ordinateur), rien.
 */
export function desabonnerAvantDeSortir(): Promise<void> {
  return Promise.race([desabonnerCetAppareil(), new Promise<void>((resoudre) => setTimeout(resoudre, 4000))]);
}
